module.exports = __webpack_public_path__ + "img/Invasion-OPSCC_PMID37704757.402ec2bf.png";